module.exports = __webpack_public_path__ + "img/alert.7d976cae.png";